import { ApiResponse } from 'common/ApiPayloadsDocument';

const get = async () => {
  throw new Error('NOT IMPLEMENTED!');
};

const post = async <RequestPayload, Response extends ApiResponse = ApiResponse>(
  url: string,
  payload: RequestPayload,
  options: { timeout?: number; delay?: number; successDelay?: number } = {}
): Promise<Response> => {
  const timeout = options.timeout ?? 2 * 60 * 1000;
  const delay = options.delay ?? 0;
  const successDelay = options.successDelay ?? 0;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);
  const startTime = Date.now();

  const isDevelopment = window?.location.hostname === 'localhost';

  try {
    const response = await fetch(`https://${window.viteClientEnv.APP_HOSTNAME}/api${url}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      signal: controller.signal,
      body: JSON.stringify(payload ?? {}),
      credentials: isDevelopment ? 'include' : 'same-origin',
    });

    clearTimeout(timer);

    if (response.status === 403) {
      return { status: 'login required' } as Response;
    }

    let data;
    try {
      data = await response.json();
    } catch (e) {
      return await apiResponse('json error', startTime, delay);
    }
    if (!data) return await apiResponse('unknown error', startTime, delay, { code: response.status });

    if (response.status === 400) {
      return await apiResponse('payload validation failed', startTime, delay, data);
    }

    if (response.status !== 200) return await apiResponse('unknown error', startTime, delay, data);

    if (data.status !== 'ok') return await apiResponse(data.status, startTime, delay, data);

    return await apiResponse('ok', startTime, successDelay, data);
  } catch (error) {
    console.log(error);
    return await apiResponse('network error', startTime, delay);
  }
};

const apiResponse = async (status: string, startTime: number, delay: number, params?: any) => {
  const timeElapsed = Date.now() - startTime;

  if (delay && timeElapsed < delay) {
    await sleep(delay - timeElapsed);
  }

  if (status === 'ok') return params;

  return { status, ...params };
};

const sleep = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

const Api = {
  get,
  post,
};

export default Api;
